import { writable } from 'svelte/store'

let userDataSubscription

const userSubscription = writable({
    id : localStorage.getItem('id'),
    role : localStorage.getItem('role'),
    token: localStorage.getItem('token'),
    first_connection: localStorage.getItem('first_connection') === 'true' ? true : false,
    isAuthenticated : localStorage.getItem('authenticated') === 'true' ? true : false
});

userSubscription.subscribe(userData => userDataSubscription = userData)

const login = async (username, password) => {

    const response = await fetch(`https://home.adr1.fr/api/login`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username : username, password : password })
    })

    let result = await response.json()

    if(result.success) {
        userDataSubscription.id = result.data.user._id
        userDataSubscription.role = result.data.user.role
        userDataSubscription.token = result.data.token
        userDataSubscription.isAuthenticated = true
        userDataSubscription.first_connection = result.data.user.first_connection
        userSubscription.set(userDataSubscription)

        localStorage.setItem("id", result.data.user._id)
        localStorage.setItem("role", result.data.user.role)
        localStorage.setItem("token", result.data.token)
        localStorage.setItem("authenticated", true)
        localStorage.setItem("first_connection", result.data.user.first_connection)

        return Promise.resolve(result)
    } else {
        console.log("RES", result)
        userDataSubscription.id = null
        userDataSubscription.role = null
        userDataSubscription.token = null
        userDataSubscription.isAuthenticated = false
        userSubscription.set(userDataSubscription)

        localStorage.setItem("id", null)
        localStorage.setItem("role", null)
        localStorage.setItem("token", null)
        localStorage.setItem("authenticated", false)
        localStorage.setItem("first_connection", null)

        return Promise.reject(result)
    }

}

const setFirstConnection = (value = true) => {
    localStorage.setItem("first_connection", value)
}

const isAuthenticated = () => {
    if (userDataSubscription.isAuthenticated) return true
    return false
}

const hasAuthorization = (roleNeeded = null) => {
    console.log(userDataSubscription.role, ' === ', roleNeeded)
    if(userDataSubscription.role === roleNeeded) return true
    return false
}

const getToken = () => {
    if (userDataSubscription.isAuthenticated) return userDataSubscription.token
    return null
}

export default {
    userSubscription,
    isAuthenticated,
    hasAuthorization,
    setFirstConnection,
    getToken,
    login
} 